///<reference path="../../../../components/goals/goalBase.controller.ts" />

module Meevo.Components.Controls {

    declare let d3: any;

    import GoalInputTypeEnum = Meevo.Components.Goals.GoalInputTypeEnum;

    class MeevoGoalsChartLabelsComponent implements angular.IComponentController {

        static $inject = ['$scope'];
        public goalDecimal: number;
        public actualDecimal: number;
        public chartClass: string;
        public parent: any;
        public goal: number;
        public actual: number;
        public numberDisplayType: number;
        public percentUpDown: number;
        public differenceText: string;
        public smallerFont: boolean;
        public goalText: string;
        public actualText: string;
        public innerWidth: number;
        public isMobile: boolean;

        constructor(private $scope: ng.IScope) { }


        $onInit = () => {

            this.innerWidth = window.innerWidth;

            this.isMobile = window.innerWidth <= 450;
            this.$scope.$watch(() => this.parent.currentGoalsModel, (value) => {

                if (!value) return;
                this.setNumberLabels();
            });

            this.$scope.$watch(() => this.parent.selectedDateRange, (value) => {

                if (!value) return;
                this.setNumberLabels();

            });


        }
        private isValidData(num: number): boolean {
            return (!_.isUndefined(num) && !_.isUndefined(num) && !_.isNaN(num) && !_.isNull(num))
        }

        private calculatePlusMinus(numGoal: number, numActual: number) {

            this.differenceText = '100%';
            let difference: number = 0;
            this.smallerFont = false;

            if (numGoal > 0 && this.isValidData(numGoal) && this.isValidData(numActual) && numActual > 0) {
                difference = Math.abs(numGoal - numActual);
                this.percentUpDown = difference / numGoal;
                this.differenceText = (this.percentUpDown * 100).toFixed(2) + '%';
                this.smallerFont = this.differenceText.length > 3;
            }

        }

        public setNumberLabels() {
            this.calculatePlusMinus(this.goal, this.actual);

            switch (this.numberDisplayType) {

                case GoalInputTypeEnum.Numeric:
                case GoalInputTypeEnum.Currency:

                    if (!this.isValidData(this.actual)) {
                        this.actualText = '0'
                    }
                    else if (this.isValidData(this.actual)) {
                        this.actualText = this.actual.toFixed(2).toString();
                    }
                    else {
                        this.actualText = '-';
                    }

                    if (!_.isUndefined(this.goal) && !_.isUndefined(this.goal) && !_.isNaN(this.goal) && !_.isNull(this.goal)) {
                        this.goalText = this.goal.toFixed(2).toString();
                    }
                    else {
                        this.goalText = '-';
                    }

                    break;

                    case GoalInputTypeEnum.Percentage:

                    if (!this.isValidData(this.actual)) {
                        this.actualText = '0%'
                    }
                    else if (this.isValidData(this.actual)) {
                        this.actualText = (this.actual * 100).toFixed(0) + '%';
                    }
                    else {
                        this.actualText = '-';
                    }

                    if (!this.isValidData(this.goal)) {
                        this.goalText = '-';
                    }
                    else if (this.isValidData(this.goal)) {
                        this.goalText = (this.goal * 100).toFixed(0) + '%';
                    }

                    break;

                default:
                    break;
            }
        }


    }


    angular.module('meevo.components.controls')
        .component('meevoGoalsChartLabelsComponent', <angular.IComponentOptions>{
            templateUrl: 'app/components/controls/charts/chartLabels/chartLabels.template.html',
            controller: MeevoGoalsChartLabelsComponent,
            controllerAs: 'vm',
            bindings: {
                chartClass: '@?',
                goal: '<?',
                actual: '<?',
                currentGoalsModel: '=',
                numberDisplayType: '<',
                selectedDateRange: '='
            },
            require: {
                parent: '^^meevoGoalsTileComponent'
            }
        });
}